import React,{ useEffect }  from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

// Components
import Layout from './components/Layout/Layout';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Games from './pages/Games/Games';
import Players from './pages/Players/Players';
import Matches from './pages/Matches/Matches';
import Tournaments from './pages/Tournaments/Tournaments';
import News from './pages/News/News';
import Achievements from './pages/Achievements/Achievements';
import Finance from './pages/Finance/Finance';
import Payouts from './pages/Payouts/Payouts';
import SupportTickets from './pages/SupportTickets/SupportTickets';
import TicketDetail from './pages/SupportTickets/TicketDetail';
import Ranks from './pages/Ranks/Ranks';
import Sliders from './pages/Sliders/Sliders';
import AdminPayouts from './pages/AdminPayouts/AdminPayouts';
import PrizeStructures from './pages/PrizeStructures/PrizeStructures';
import LoadingSpinner from './components/UI/LoadingSpinner';
import { App as CapacitorApp } from '@capacitor/app';

const AppContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);
  color: #ffffff;
`;

const App = () => {
  const { isLogin, loading } = useSelector((state) => state.auth);

  useEffect(() => {
    CapacitorApp.addListener('backButton', () => {
      window.history.back();
    });
  }, []);

  if (loading) {
    return (
      <AppContainer>
        <LoadingSpinner />
      </AppContainer>
    );
  }

  if (!isLogin) {
    return (
      <AppContainer>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AppContainer>
    );
  }

  return (
    <AppContainer>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/games" element={<Games />} />
          <Route path="/players" element={<Players />} />
          <Route path="/matches" element={<Matches />} />
          <Route path="/tournaments" element={<Tournaments />} />
          <Route path="/news" element={<News />} />
          <Route path="/achievements" element={<Achievements />} />
          <Route path="/finance" element={<Finance />} />
          <Route path="/admin-payouts" element={<AdminPayouts />} />
          <Route path="/payouts" element={<Payouts />} />
          <Route path="/ranks" element={<Ranks />} />
          <Route path="/sliders" element={<Sliders />} />
          <Route path="/prize-structures" element={<PrizeStructures />} />
          <Route path="/support-tickets" element={<SupportTickets />} />
          <Route path="/support-tickets/:id" element={<TicketDetail />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </AppContainer>
  );
};

export default App;
